import { render, staticRenderFns } from "./CardRenderSymbolComponent.vue?vue&type=template&id=a1988aee&"
import script from "./CardRenderSymbolComponent.vue?vue&type=script&lang=ts&"
export * from "./CardRenderSymbolComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports